import { Container, Form, Row } from 'react-bootstrap';
import { ControlButtons } from '../ControlButtons';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { conditionSchema } from '../../schemas/conditionSchema';
export function BurnConditions({
	currCondition = {},
	onNext = () => {},
	onPrevious = () => {},
	onSubmit = () => {},
	finalStep = false,
	disablePrev = false,
	disableNext = false,
	enableLoading = false,
}) {
	const { formState, register, handleSubmit } = useForm({
		resolver: yupResolver(conditionSchema),
		defaultValues: currCondition,
	});

	return (
		<>
			<Container className="mb-4 mt-5">
				<Row>
					<div className="mb-4">
						<h2 className="mb-4">Burn Conditions</h2>
						<h3 className="mb-3">
							PERMIT SUBJECT TO THE FOLLOWING CONDITIONS:
						</h3>
						<ol>
							<li className="mb-2">
								Prior to burning- Notify the local police and fire authorities
								by accessing the website: utahcounty.gov/burn; a link can be
								found at utahcounty.gov.
							</li>
							<li className="mb-2">
								*When atmospheric conditions (clearing index) indicates it is
								satisfactory to burn. This information may be obtained at the
								website listed above. (Applies to Open Burn Permits only). Note:
								for those without internet access call 801-851-2876
							</li>
							<li className="mb-2">
								Burning shall not be done when circumstances make such fires
								hazardous; i.e. high winds, red flag, etc.
							</li>
							<li className="mb-2">
								Burning shall be done at a distance of more than 50 feet from
								any building, structure, or other combustibles.
							</li>
							<li className="mb-2">
								An adequate water supply or other fire extinguishing equipment
								shall be available.
							</li>
							<li className="mb-2">
								The burning area shall be constantly attended by a competent
								person and shall be completely extinguished before being left.
								All fires shall be completely extinguished before dark.
							</li>
							<li className="mb-2">
								Applicant must be in legal control of the land on which the
								burning is to take place.
							</li>
							<li className="mb-2">
								Approved fuel breaks shall be established between the controlled
								burning area and any endangered property. (The width of fuel
								breaks shall be determined by height, type, and amount of
								growth, wind conditions, geographical conditions, and type of
								exposure.)
							</li>
							<li className="mb-2">
								Adjacent neighbors shall be notified prior to burning.
							</li>
							<li className="mb-2">
								Such burning shall not pose a threat to forest, range, or
								watershed lands.
							</li>
							<li className="mb-2">
								Notification by applicant to the BURN notification website is
								required for each day of burning.
							</li>
							<li className="mb-2">
								Applicant agrees to burn only during valid burning dates for
								which permit is issued.
							</li>
							<li className="mb-2">
								Applicant certifies that their burn site is located in
								unincorporated Utah County, and understands this permit does not
								allow burning in city limits
							</li>
						</ol>
						<p className="mb-3">
							*REQUIRED CONDITIONS FOR OPEN BURN PERMITS; RECOMMENDED FOR
							AGRICULTURAL PERMITS
						</p>
						<p>
							- FAILURE TO COMPLY WITH ALL CONDITIONS MAY RESULT IN A CITATION
							BEING ISSUED TO APPLICANT AND/OR REVOCATION OF THIS PERMIT.
						</p>
						<p>
							- ABSOLUTELY NO BURNING OF TIRES, PLASTIC PRODUCTS, COATED WIRE,
							OR BUILDING PRODUCTS. ITEMS NOT GROWN ON THE PROPERTY, CANNOT BE
							BURNED.
						</p>
						<p>
							A burning permit is subject to the laws of the State of Utah, Utah
							County laws, and the conditions stated upon permit. The Utah
							County Fire Marshal reserves the right to refuse, revoke, or
							postpone the permit when the Fire Marshal deems it necessary to
							prevent danger to life or property. This permit shall in no way
							relieve any individual from personal liability due to neglect or
							incompetence. Any person responsible for the existence or spread
							of fire necessitating suppression action shall be liable for the
							payment of costs.
						</p>
					</div>
				</Row>

				<Row>
					<Form.Group>
						<Form.Check>
							<Form.Check.Input {...register('agreed')} />
							<Form.Check.Label>
								<strong>
									I have read the above permit and agree to follow the
									conditions set forth: By signing this document, I understand
									and acknowledge to comply with all Utah County and Utah State
									requirements to conduct a controlled burn.
								</strong>
							</Form.Check.Label>
						</Form.Check>
						<Form.Text className="text-danger">
							{formState.errors.agreed?.message}
						</Form.Text>
					</Form.Group>
				</Row>
			</Container>
			<ControlButtons
				onNext={handleSubmit(onNext)}
				onPrev={onPrevious}
				onSubmit={handleSubmit(onSubmit)}
				finalStep={finalStep}
				disablePrev={disablePrev}
				disableNext={disableNext}
				enableLoading={enableLoading}
			/>
		</>
	);
}
